export const STOCK_TRACK_PENDING_KEY = 'policy-intel:stock-track-pending:v1';
export const STOCK_TRACK_PENDING_MAX_AGE_MS = 30 * 60 * 1000;

export type PendingStockTrackAction = {
  type: 'WATCHLIST';
  ticker: string;
  name?: string;
  source?: 'main-guest-preview' | 'stock-seo';
  intentId?: string;
  createdAt: number;
};

function cleanTicker(value: unknown): string {
  return String(value ?? '').replace(/\D/g, '');
}

function cleanText(value: unknown): string {
  return String(value ?? '').replace(/\s+/g, ' ').trim();
}

export function readStockTrackPending(): PendingStockTrackAction | null {
  try {
    const raw = localStorage.getItem(STOCK_TRACK_PENDING_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<PendingStockTrackAction>;
    const ticker = cleanTicker(parsed.ticker);
    const createdAt = Number(parsed.createdAt || 0);

    if (
        parsed.type !== 'WATCHLIST'
        || !/^\d{6}$/.test(ticker)
        || !createdAt
        || Date.now() - createdAt > STOCK_TRACK_PENDING_MAX_AGE_MS
    ) {
      localStorage.removeItem(STOCK_TRACK_PENDING_KEY);
      return null;
    }

    const source = parsed.source === 'main-guest-preview' || parsed.source === 'stock-seo'
        ? parsed.source
        : undefined;
    const intentId = cleanText(parsed.intentId) || undefined;

    return {
      type: 'WATCHLIST',
      ticker,
      name: cleanText(parsed.name),
      source,
      intentId,
      createdAt,
    };
  } catch {
    localStorage.removeItem(STOCK_TRACK_PENDING_KEY);
    return null;
  }
}

export function saveStockTrackPending(action: PendingStockTrackAction): void {
  try {
    localStorage.setItem(STOCK_TRACK_PENDING_KEY, JSON.stringify(action));
  } catch {
    // Storage failure must not block authentication or the explicit Track action.
  }
}

export function clearStockTrackPending(): void {
  try {
    localStorage.removeItem(STOCK_TRACK_PENDING_KEY);
  } catch {
    // Best-effort cleanup only.
  }
}
